<template>
    <div class="g pop-up-inner">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="$t('site.func.contactsales')"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="g">
                    <div class="md sales">
                        <div class="fieldset">
                            <div class="cp user-photo">
                                <div class="figure">
                                    <div
                                        class="img"
                                        :style="'background-image: url('+ content.photo +');'"
                                    >
                                        <img :src="content.photo" :alt="user.cuno">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="fieldset">
                            <label>{{ $t('page.myaccount.caption.representitive') }}</label>
                            <div class="cp input div">
                                <div class="text">
                                    {{ content.salename }}
                                </div>
                            </div>
                        </div>
                        <div class="fieldset" v-if="content.email">
                            <label>E-mail</label>
                            <div class="cp input div">
                                <div class="text">
                                    <a :href="'mailto:'+ content.email">{{ content.email }}</a>
                                </div>
                            </div>
                        </div>
                        <div class="fieldset">
                            <label> {{ $t('site.noun.phone') }}</label>
                            <div class="cp input div">
                                <div class="text">
                                    {{ content.phone }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </div>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'

    import { mapState, mapMutations } from 'vuex'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: { //依照模板定義
                require: false,
                default: () => {
                    return {}
                }
            }
        },
        data: function(){

            return {
                password: '',
            }
        },
        computed: {
            ...mapState([
                'user',
                'talk',
                'productList',
            ]),
            btns: function(){
                let $talk = {
                        text: this.$t('site.func.talk'),
                        themes: 'info',
                        func: 'talkOpen',
                    },
                    $cancel = {
                        text: this.$t('site.func.popupclose'),
                        func: 'close',
                    }

                let $result = [
                        $cancel,
                    ]

                if( this.talk.aid ) {
                    $result.unshift($talk)
                }

                return $result;
            },
        },
        methods: {
            ...mapMutations([
                'talkCreate',
                'talkSet',
                'pushPopUp',
            ]),
            talkOpen: async function(){
                let _saleid = this.content.saleid;

                if( this.$siteConfig.devEvent ) { //測試機就給我
                    _saleid = 'n000170609'
                }

                let _url = this.$siteConfig.talkAccountUrl,
                    $form = new URLSearchParams({
                        account: _saleid,
                        accessToken: this.talk.accessToken,
                    });
                    
                try {
                    let $response = await this.$http.post(_url, $form),
                        $data = $response.data;

                    let $_core = () => {
                            this.talkCreate($data.data.aid); //創造一個聊天
                            this.close();
                        }
                   
                    if( $data.result === 'SUCCESS' ) {
                        let $content = this.content;

                        if( $content.product_sn ) {
                            let _product_sn = $content.product_sn,
                                $product = this.productList.find(product => product.product_sn === _product_sn),
                                _class= $product.class[0],
                                $location = window.location,
                                _origin = $location.origin,
                                _pathname = $location.pathname,
                                _url = _origin + _pathname +'#/system/productList?class='+ _class +'&product=all&item='+ _product_sn;

                            this.talkSet({
                                nextSend: _url,
                            });

                            $_core();
                        }else if( $content.nextSend ) { //目前只有訂單在用，要跳 popup 給他寫意見
                            let _nextSend = $content.nextSend;

                            this.pushPopUp({
                                type: 'prompt',
                                content: {
                                    caption: this.$t('order.info.requestInput'),
                                    html: _nextSend,
                                    type: 'textarea',
                                    action: (val) => {

                                        if( val ) {
                                            _nextSend += '<br>'+ this.$t('order.info.request') +': '+ val;
                                        }

                                        _nextSend = _nextSend.replaceAll('<br>', '\r\n');

                                        this.talkSet({
                                            nextSend: _nextSend,
                                        });

                                        $_core();
                                    }
                                }
                            });
                        }else {
                            $_core();
                        }
                    }else {
                        console.error($data);
                    }

                }catch(error) {
                    console.log(error)
                }
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            }
        }
    }
</script>

<style scoped lang="scss">

    .cp.user-photo {
        $size: 144px;
        $lh: 36px;

        position: relative;
        width: $size;
        margin: 0 auto;
        border-radius: 100px;
        border: 1px solid $gray;
        overflow: hidden;

        .figure {
            position: relative;
            height: $size;
            text-align: center;
            background-color: $white;

            .img {
                @extend %fill-image;
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
        
                img {
                    display: none;
                }
            }

            &::after {
                @extend %font-pseudo;
                content: '\e87c';
                display: block;
                line-height: $size;
                font-size: $size;
                color: $major-color;
            }
        }
    }

    .fieldset {
        padding: $interval-xs 0;

        label {
            display: block;
            margin-bottom: $interval-s;
        }

        div {
            @include media('mobile') {
                width: 100%
            }
        }
    }
</style>
